import nacl from 'tweetnacl';
import naclUtils from 'tweetnacl-util';

export function hash(message: string | null): string {
  if (!message) {
    return '';
  }
  return naclUtils.encodeBase64(nacl.hash(naclUtils.decodeUTF8(message)));
}
